/* global showSuccessToast */
/* global showWarningToast */
import React, { useState, useEffect, use, useContext } from "react";
import { getBookmarks, addBookmark, getAssetsIdByPath } from "../api/api";
import CardWithLogo from "./elements/CardWithLogo";
import FooterBar from './layout/FooterBar';
import FooterButton from './tools/FooterButton';
import globals from '../config/globals.json'
import { getCredentials, addCredentials, updatePassword } from "../api/api";
import CryptoJS from "crypto-js";
import config from "../config/api.json";
import { SearchContext } from "./layout/SearchContext";

const Bookmarks = (props) => {
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;
    const { searchTerm } = useContext(SearchContext);
    const [bookmarks, setBookmarks] = useState([]);
    const [credentials, setCredentials] = useState([]);
    const [credentialsLoading, setCredentialsLoading] = useState(false);
    const [bookmarksLinks, setBookmarksLinks] = useState([]);
    const [allLinks, setAllLinks] = useState([]);
    const [credentialsIndex, setCredentialsIndex] = useState({});
    const [selectedCategory, setSelectedCategory] = useState({ id: null, name: "" });
    const [selectedBookmark, setSelectedBookmark] = useState(null);
    const [selectedCredential, setSelectedCredential] = useState(null);
    const [carriersLogos, setCarriersLogos] = useState([]);
    const [password, setPassword] = useState("");
    const [decryptedPassword, setDecryptedPassword] = useState("");
    const [originalText, setOriginalText] = useState("");

    const crypt = (password) => {
        return CryptoJS.AES.encrypt(password, config.CRYPT_KEY, { iv: config.CRYPT_IV }).toString();
    }

    const decrypt = (ciphertext) => {
        const bytes = CryptoJS.AES.decrypt(ciphertext, config.CRYPT_KEY, { iv: config.CRYPT_IV });
        return bytes.toString(CryptoJS.enc.Utf8);
    };

    const fetchCredentials = async (selectedBookmark) => {
        try {
            const response = await getCredentials(companyID, selectedBookmark ? selectedBookmark.id : null);
            if (response.data.data.getCredentialsListing.edges.length > 0) {
                setCredentials(response.data.data.getCredentialsListing.edges); // Imposta tutte le credenziali
                if (selectedBookmark) {
                    setCredentialsIndex((prev) => ({
                        ...prev,
                        [selectedBookmark.id]: response.data.data.getCredentialsListing.edges.map((c) => ({
                            name: c.node.name,
                            username: (c.node.username || "").replace(/^\|/, "")
                        }))
                    }));
                }
            }
        } catch (error) {
            console.error("Error fetching credentials:", error);
        }
    };

    const fetchBookmarks = async () => {
        try {
            const response = await getBookmarks(companyID);
            setBookmarks(response.data.data.getAppListing.edges);
        } catch (error) {
            console.error("Error fetching bookmarks:", error);
        }
    };

    const fetchBookmarksLinks = async (parentID, parentName) => {
        try {
            const response = await getBookmarks(companyID, parentID);
            setSelectedCategory({ id: parentID, name: parentName });
            setBookmarksLinks(response.data.data.getAppListing.edges);
        } catch (error) {
            console.error("Error fetching bookmarks:", error);
        }
    };

    const selectBookmark = async (bookmark) => {
        try {
            setSelectedBookmark(bookmark);
        } catch (error) {
            console.error("Error selecting bookmark:", error);
        }
    };

    const fetchCarriersLogos = async (parentID, parentName) => {
        try {
            const response = await getAssetsIdByPath("%2Freboot%2Flogos%25");
            setCarriersLogos(response.data.data.getAssetListing.edges);
        } catch (error) {
            console.error("Error fetching carriers logos:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Costruisci i dati del bookmark
        const plainData = {
            name: e.target.title.value,
            subTitle: e.target.subTitle.value,
            url: e.target.link.value,
            target: e.target.target.value,
            logo: e.target.logo.value
        };

        // Replace colons in URL with %3A
        if (plainData.url.includes(":")) {
            plainData.url = plainData.url.replace(/:/g, "%3A");
        }

        // 2. Aggiungi il bookmark
        const response = await addBookmark(selectedCategory.id, plainData);

        // 3. Chiudi la modale
        window.$("#modal-add-bookmark").modal("hide");

        // 4. Aggiorna la lista dei bookmark
        await fetchBookmarksLinks(selectedCategory.id, selectedCategory.name);

        // 5. Resetta il form
        e.target.reset();
    };

    const handleSubmitCredentials = async (e) => {
        e.preventDefault();

        // 1. Costruisci i dati della credenziale
        const credentialData = {
            name: e.target.name.value,
            username: e.target.username.value ? "|" + e.target.username.value : "|", // Se il campo username è vuoto, invia una stringa contenente "|" per evitare errori di validazione lato server
            password: crypt(e.target.password.value) // Assicurati di criptare la password prima di inviarla
        };

        // 2. Aggiungi la credenziale
        const response = await addCredentials(selectedBookmark.id, credentialData);

        // 3. Chiudi la modale
        // window.$("#modal-add-credentials").modal("hide");

        // 4. Aggiorna la lista delle credenziali
        await fetchCredentials(selectedBookmark);
        showSuccessToast("Credenziali aggiunte con successo!");

        // 5. Resetta il form
        e.target.reset();
    };

    const changePassword = async (id, newPassword) => {
        // e.preventDefault();

        // 1. Costruisci i dati della credenziale
        const credentialData = {
            password: crypt(newPassword) // Assicurati di criptare la password prima di inviarla
        };

        setPassword(newPassword);
        if (newPassword && selectedBookmark) {
            const response = await updatePassword(id, credentialData);
            await fetchCredentials(selectedBookmark);
            showSuccessToast("Password aggiornata con successo!");
        }
    }

    const resetSelectedBookmark = () => {
        setCredentials([]);
        setDecryptedPassword();
        setOriginalText("");
        setPassword("");
        setSelectedCredential(null);
    };

    useEffect(() => {
        if (!companyID) return; // Se companyID non è disponibile, non fare nulla
        fetchBookmarks();
        fetchCarriersLogos();
    }, [companyID]);

    const fetchAllLinks = async () => {
        try {
            const categories = bookmarks.filter((b) => props.userDetails.role <= b.node.permission);
            const results = await Promise.all(
                categories.map((c) => getBookmarks(companyID, c.node.id).then((r) =>
                    r.data.data.getAppListing.edges.map((e) => ({ ...e, category: c }))
                ))
            );
            setAllLinks(results.flat());
        } catch (error) {
            console.error("Error fetching all bookmarks links:", error);
        }
    };

    useEffect(() => {
        if (!companyID || bookmarks.length === 0) return;
        fetchAllLinks();
    }, [companyID, bookmarks, bookmarksLinks]);

    useEffect(() => {
        if (!selectedBookmark) return;
        setCredentialsLoading(true);
        fetchCredentials(selectedBookmark).finally(() => setCredentialsLoading(false));
        resetSelectedBookmark();
    }, [selectedBookmark]);

    useEffect(() => {
        if (!decryptedPassword) return;
        setPassword(document.getElementById("crypted")?.textContent || decryptedPassword);
        setOriginalText(decrypt(decryptedPassword));
    }, [decryptedPassword]);

    const normalizedSearchTerm = searchTerm.trim().toLowerCase();

    const toCredentialIndex = (edges) => edges.map((c) => ({
        name: c.node.name,
        username: (c.node.username || "").replace(/^\|/, "")
    }));

    // Carica (una sola volta per link) nome e username delle credenziali quando si cerca
    useEffect(() => {
        if (!normalizedSearchTerm || allLinks.length === 0) return;
        const missing = allLinks.filter((l) => !(l.node.id in credentialsIndex));
        if (missing.length === 0) return;
        let cancelled = false;
        Promise.all(missing.map((l) =>
            getCredentials(companyID, l.node.id)
                .then((r) => [l.node.id, toCredentialIndex(r.data.data.getCredentialsListing.edges)])
                .catch(() => [l.node.id, []])
        )).then((entries) => {
            if (!cancelled) setCredentialsIndex((prev) => ({ ...prev, ...Object.fromEntries(entries) }));
        });
        return () => { cancelled = true; };
    }, [normalizedSearchTerm, allLinks]);

    const matchesBookmarkSearch = (bookmark) => {
        const node = bookmark.node || {};
        const credentialsText = (credentialsIndex[node.id] || [])
            .map((c) => `${c.name} ${c.username}`);
        const text = [node.name, node.subTitle, node.url, ...credentialsText]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
        // Ogni porzione di parola digitata deve comparire in un punto qualsiasi del testo
        return normalizedSearchTerm.split(/\s+/).every((token) => text.includes(token));
    };

    // Con una ricerca attiva si cercano i link in tutte le categorie
    const visibleLinks = normalizedSearchTerm
        ? allLinks.filter((link) => matchesBookmarkSearch(link) || matchesBookmarkSearch(link.category))
        : bookmarksLinks;

    return (
        <div className="container-fluid bookmarks-page">
            {bookmarks && bookmarks.length > 0 ? (
                <>
                <h2 className="bm-section-title">Categorie</h2>
                <div className="bm-categories">
                    {bookmarks.filter((bookmark) => (
                        props.userDetails.role <= bookmark.node.permission && matchesBookmarkSearch(bookmark)
                    )).map((bookmark) => (
                        (
                            <CardWithLogo
                                variant="category"
                                selected={selectedCategory.id === bookmark.node.id}
                                key={bookmark.node.id}
                                icon={bookmark.node.icon}
                                logo={bookmark.node.logo}
                                name={bookmark.node.name}
                                subTitle={bookmark.node.subTitle}
                                target={bookmark.node.target || "_self"}
                                fetchBookmarksLinks={() => fetchBookmarksLinks(bookmark.node.id, bookmark.node.name)}
                            />
                        )
                    ))}
                </div>
                </>
            ) : null}

            {visibleLinks.length > 0 ? (
                <>
                <h2 className="bm-section-title">
                    {normalizedSearchTerm ? "Risultati" : selectedCategory.name || "Link"}
                    <span className="bm-count">{visibleLinks.length}</span>
                </h2>
                <div className="bm-links">
                    {visibleLinks.map((bookmark) => (
                        <CardWithLogo
                            key={bookmark.node.id}
                            icon={bookmark.node.icon}
                            logo={bookmark.node.logo}
                            name={bookmark.node.name}
                            subTitle={bookmark.node.subTitle}
                            // url={bookmark.node.url ? bookmark.node.url.replace(/%3A/g, ":") : "#"}
                            modal={"modal-add-credentials"}
                            target={bookmark.node.target || "_self"}
                            selectBookmark={() => selectBookmark(bookmark.node)}
                        />
                    ))}
                </div>
                </>
            ) : (
                <p className="bm-empty">
                    {normalizedSearchTerm ? "Nessun risultato" : "Seleziona una categoria per vedere i link"}
                </p>
            )}

            {/* MODAL ADD BOOKMARK */}
            <div className="modal fade" id="modal-add-bookmark" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{ borderTopLeftRadius: "inherit", borderTopRightRadius: "inherit" }}>
                            <h5 className="modal-title" id="exampleModalCenterTitle">Aggiungi link in {selectedCategory?.name}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {selectedCategory?.id && (
                                <div className="row">
                                    <div className="col-12">
                                        <div>
                                            <div className="card-body">
                                                <form className="forms-sample" method="post" onSubmit={handleSubmit}>
                                                    <input type="hidden" name="parentID" value={selectedCategory.id} />
                                                    <input type="hidden" id="logo" name="logo" value="" />

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail3">Titolo</label>
                                                                <input type="text" className="form-control" id="title" name="title" required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail3">Sottotitolo</label>
                                                                <input type="text" className="form-control" id="subTitle" name="subTitle" required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputPassword4">Link</label>
                                                                <input type="text" className="form-control" id="link" name="link" placeholder="Incolla il link" required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputPassword4">Apri link in</label>
                                                                <select className="form-control" id="target" name="target">
                                                                    <option value="_blank">Nuova finestra</option>
                                                                    <option value="_self">Stessa finestra</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputPassword4">&nbsp;</label>
                                                                <div className="dropdown">
                                                                    <button className="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-expanded="false" >
                                                                        Scegli logo
                                                                    </button>
                                                                    <img src="" alt="" id="logoPreview" style={{ width: "33px", marginLeft: "10px" }} />
                                                                    <ul className="dropdown-menu shadow" aria-labelledby="dropdownMenuButton1" style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}>
                                                                        {carriersLogos && carriersLogos.map(({ node }) => (
                                                                            node.filename ? (
                                                                                <li key={node.id}>
                                                                                    <a className="dropdown-item" href="#nothing" onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        document.getElementById("logo").value = node.id;
                                                                                        document.getElementById("logoPreview").src = `${globals.IMAGE_PATH.GENERIC}${node.fullpath}`;
                                                                                    }}>
                                                                                        <img src={`${globals.IMAGE_PATH.GENERIC}${node.fullpath}`} alt={node.filename} style={{ width: "30px", marginRight: "10px" }} />
                                                                                        {node.filename}
                                                                                    </a>
                                                                                </li>
                                                                            )
                                                                                : null
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-right">
                                                            <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annulla</button>
                                                            <button type="submit" className="btn btn-primary">Conferma</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL ADD CREDENTIALS */}
            <div className="modal fade" id="modal-add-credentials" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content" style={{ overflow: "hidden" }}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">{selectedBookmark?.name} - <small>{selectedBookmark?.subTitle.toUpperCase()}</small></h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {selectedBookmark && (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card-body">
                                            <div className="row my-3 mb-35">
                                                <div className="col-12">
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="button-addon2" value={selectedBookmark?.url.replace(/%3A/g, ":")} readOnly />
                                                        <div className="input-group-append">
                                                            <a className="btn btn-primary bookmarks-open-link" href={selectedBookmark?.url.replace(/%3A/g, ":")} target="_blank" rel="noopener noreferrer" id="button-addon2">
                                                                Apri link
                                                                <span className="material-symbols-outlined" aria-hidden="true">open_in_new</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {credentialsLoading ? (
                                                <div className="text-center my-4">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : credentials && credentials.length > 0 ? (
                                                credentials.map((credential) => (
                                                    <div key={credential.node.id}>
                                                        <hr className="mt-1 mb-3" />
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text" id="basic-addon1">{credential.node.name}</span>
                                                                    </div>
                                                                    <input type="text" className="form-control" defaultValue={credential.node.username.substring(1)} disabled />
                                                                    <div className="input-group-append">
                                                                        <button type="button" className="btn btn-light border p-2" onClick={() => navigator.clipboard.writeText(credential.node.username.substring(1))}>
                                                                            <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                                                                content_copy
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="input-group">
                                                                    <input type={selectedCredential === credential.node.id ? "text" : "password"} id={`decrypted-${credential.node.id}`} className="form-control" defaultValue={originalText || "**************"} />
                                                                    {selectedCredential === credential.node.id ? (
                                                                        <div className="input-group-append">
                                                                            <button type="button" className="btn btn-light border p-2" onClick={() => changePassword(credential.node.id, document.getElementById(`decrypted-${credential.node.id}`).value)}>
                                                                                <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                                                                    save
                                                                                </span>
                                                                            </button>
                                                                        </div>
                                                                    ) : null}
                                                                    {selectedCredential === credential.node.id ? (
                                                                        <div className="input-group-append">
                                                                            <button type="button" className="btn btn-light border p-2" onClick={() => navigator.clipboard.writeText(originalText)}>
                                                                                <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                                                                    content_copy
                                                                                </span>
                                                                            </button>
                                                                        </div>
                                                                    ) : null}
                                                                    <div className="input-group-append">
                                                                        <button type="button" className={`btn ${selectedCredential === credential.node.id ? "btn-success p-2" : "btn-secondary p-2"}`} onClick={() => { setDecryptedPassword(credential.node.password); setSelectedCredential(credential.node.id); document.getElementById(`decrypted-${credential.node.id}`).value = decrypt(credential.node.password); }}>
                                                                            <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                                                                {selectedCredential === credential.node.id ? "lock_open_right" : "lock"}
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                ""// <p>Non ci sono credenziali per questo bookmark.</p>
                                            )}

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="border-top my-3 text-right">
                                                        <button type="button" onClick={() => document.getElementById('add-credentials-form').classList.toggle('hidden')} className="btn m-0 p-0" style={{ position: "relative", top: "-14px", left: "5px" }}>
                                                            <span className="material-symbols-outlined">
                                                                add_circle
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <form id="add-credentials-form" className="forms-sample hidden" method="post" onSubmit={handleSubmitCredentials}>
                                                <input type="hidden" name="parentID" value={selectedBookmark?.id} />
                                                <input type="hidden" id="logo" name="logo" value="" />

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail3">Descrizione</label>
                                                            <input type="text" className="form-control" id="name" name="name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail3">Username</label>
                                                            <input type="text" className="form-control" id="username" name="username" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail3">Password</label>
                                                            <input type="text" className="form-control" id="password" name="password" required />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12 text-right">
                                                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annulla</button>
                                                        <button type="submit" className="btn btn-primary">Aggiungi</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <FooterBar
                footerIcon={"star"}
                footerTitle={"Link utili"}
                footerButton={selectedCategory.id ? (
                    <FooterButton icon="add" title="Aggiungi link" action={void 0} target="#modal-add-bookmark" />
                ) : (<FooterButton icon="add" title="Aggiungi link" action={() => showWarningToast("Seleziona prima una categoria per aggiungere un link")}/>)}
            />
        </div>
    );
};
export default Bookmarks;